import { render } from "./FluidHeightTableWithFixedHeaderAndColumns.vue?vue&type=template&id=0d6ba501"
import script from "./FluidHeightTableWithFixedHeaderAndColumns.vue?vue&type=script&lang=ts"
export * from "./FluidHeightTableWithFixedHeaderAndColumns.vue?vue&type=script&lang=ts"
script.render = render

export default script